var map = {
	"./nav_bt_1_ns.png": "bKii",
	"./nav_bt_1_s.png": "dGwn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "syBL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st ^\.\/nav_bt_1_.*\.png$
// module id = syBL
// module chunks = 0